import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styled from 'styled-components';
import { getFilterOptions, getFooterLinks } from '../../../../new-lib/apis';
import { GetStaticPaths, GetStaticPropsContext } from 'next';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { logEvent } from '../../../../new-lib/analytics';
import ToggleSwitch from '../../../../new-components/ui/ToggleSwitch';
import {
  setExperimentVariant,
  setIsMobile,
  setWebview,
  WEBVIEW
} from '../../../../redux/actions/appActions';
import { wrapper } from '../../../../redux/store';
import { StaticPagesUtility } from '../../../../new-lib/utilities/static-pages.utility';
import { ConfigsApis } from '../../../../new-lib/apis/configs.apis';

const Privacy = () => {
  const { t } = useTranslation('privacy');
  const [userConsented, setUserConsented] = useState(false);
  const webview = useSelector((state: any) => state.app.webview);
  useEffect(() => {
    const userConsent = localStorage.getItem('userConsent');
    if (userConsent == 'true') {
      setUserConsented(true);
    } else {
      setUserConsented(false);
    }
  }, []);

  const initializeArray = (size: number) => {
    const array = [];
    for (let i = 1; i <= size; i++) {
      array.push(i);
    }
    return array;
  };
  const grantConsent = () => {
    gtag('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted'
    });
    logEvent.click('update_consent', 'privacy_policy', 'other');
    localStorage.setItem('userConsent', 'true');
    setUserConsented(true);
  };
  const denyConsent = () => {
    gtag('consent', 'update', {
      ad_storage: 'denied',
      analytics_storage: 'denied'
    });
    logEvent.click('update_consent', 'privacy_policy', 'other');
    localStorage.setItem('userConsent', 'false');
    setUserConsented(false);
  };

  const toggleConsentMode = () => {
    localStorage.getItem('userConsent') === 'true'
      ? denyConsent()
      : grantConsent();
  };

  return (
    <PrivacyContainer className="container-fluid">
      <div className="privacy-header">
        {webview !== 'app' && (
          <h1 id="privacy-header">{t('privacy_policy')}</h1>
        )}

        <p>{t('privacy_intro1')}</p>
        <p>{t('privacy_intro2')}</p>
      </div>

      <div className="privacy-content">
        <div className="privacy-section">
          <h2>{t('definitions_and_key_terms')}</h2>
          <p>{t('definitions_intro')}</p>

          <ul>
            <li>{t('definitions_cookies')}</li>
            <li>{t('definitions_company')}</li>
            <li>{t('definitions_country')}</li>
            <li>{t('definitions_customer')}</li>
            <li>{t('definitions_device')}</li>
            <li>{t('definitions_ip_address')}</li>
            <li>{t('definitions_personnel')}</li>
            <li>{t('definitions_personal_data')}</li>
            <li>{t('definitions_service')}</li>
            <li>{t('definitions_third_party_service')}</li>
            <li>{t('definitions_you')}</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>{t('info_we_collect')}</h2>
          <p>{t('info_intro')}</p>

          <ul>
            <li>{t('name_username')}</li>
            <li>{t('phone_numbers')}</li>
            <li>{t('email_addresses')}</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>{t('end_user_info_3rd_party')}</h2>
          <p>{t('end_user_info_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('use_customer_info')}</h2>
          <p>{t('use_customer_info_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('info_share')}</h2>

          <p>{t('info_share_intro1')}</p>
          <p>{t('info_share_intro2')}</p>
          <p>{t('info_share_intro3')}</p>
          <p>{t('info_share_intro4')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('when_info_collected')}</h2>
          <p>{t('when_info_collected_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('how_we_use_info')}</h2>
          <p>{t('how_we_use_info_intro')}</p>

          <ul>
            {initializeArray(6).map(item => (
              <li key={item}>{t(`how_we_use_info_${item}`)}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2>{t('how_we_use_email')}</h2>
          <p>{t('how_we_use_email_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('how_long_we_keep_info')}</h2>
          <p>{t('how_long_we_keep_info_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('how_we_protect_info')}</h2>
          <p>{t('how_we_protect_info_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('could_info_be_transferred')}</h2>
          <p>{t('could_info_be_transferred_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('is_info_collected_secure')}</h2>
          <p>{t('is_info_collected_secure_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('can_i_update_info')}</h2>
          {initializeArray(4).map(item => (
            <p key={item}>{t(`can_i_update_info_intro_${item}`)}</p>
          ))}
        </div>

        <div className="privacy-section">
          <h2>{t('personnel')}</h2>
          {initializeArray(2).map(item => (
            <p key={item}>{t(`personnel_intro_${item}`)}</p>
          ))}
        </div>

        <div className="privacy-section">
          <h2>{t('sale_of_business')}</h2>
          <p>{t('sale_of_business_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('affiliates')}</h2>
          <p>{t('affiliates_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('governing_law')}</h2>
          {initializeArray(3).map(item => (
            <p key={item}>{t(`governing_law_intro_${item}`)}</p>
          ))}
        </div>

        <div className="privacy-section" id="cookies">
          <h2>{t('your_consent')}</h2>
          <p>{t('your_consent_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('cookies')}</h2>
          <p>{t('cookies_intro')}</p>
          {webview !== 'app' && (
            <div className="consent-toggler">
              {t('allow_cookies')}
              <ToggleSwitch
                checked={userConsented}
                handleChange={toggleConsentMode}
              />
            </div>
          )}
        </div>

        <div className="privacy-section">
          <h2>{t('block_disable_cookies')}</h2>
          <p>{t('block_disable_cookies_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('remarketing_services')}</h2>
          <p>{t('remarketing_services_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('payment_details')}</h2>
          <p>{t('payment_details_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('kids_privacy')}</h2>
          <p>{t('kids_privacy_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('changes_to_policy')}</h2>
          <p>{t('changes_to_policy_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('third_party_services')}</h2>
          {initializeArray(3).map(item => (
            <p key={item}>{t(`third_party_services_intro_${item}`)}</p>
          ))}
        </div>

        <div className="privacy-section">
          <h2>{t('facebook_pixel')}</h2>
          <p>{t('facebook_pixel_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('tracking_technologies')}</h2>

          <ul>
            <div>
              <li className="bold">{t('cookies')}</li>
              <p className="description">{t('cookies_description')}</p>
            </div>

            <div>
              <li className="bold">{t('local_storage')}</li>
              <p className="description">{t('local_storage_description')}</p>
            </div>

            <div>
              <li className="bold">{t('sessions')}</li>
              <p className="description">{t('sessions_description')}</p>
            </div>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>{t('gdpr')}</h2>
          <p>{t('gdpr_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('what_is_gdpr')}</h2>
          <p>{t('what_is_gdpr_intro_1')}</p>
          <p>{t('what_is_gdpr_intro_2')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('what_is_personal_data')}</h2>

          {initializeArray(2).map(item => (
            <p key={item}>{t(`what_is_personal_data_intro_${item}`)}</p>
          ))}

          <ul>
            {initializeArray(4).map(item => (
              <li key={item}>{t(`personal_data_intro_${item}`)}</li>
            ))}
          </ul>
        </div>

        <div className="privacy-section">
          <h2>{t('why_is_gdpr_important')}</h2>
          <p>{t('why_is_gdpr_important_intro')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('data_subject_rights')}</h2>
          <p>{t('data_subject_rights_intro_1')}</p>
          <p>{t('data_subject_rights_intro_2')}</p>
        </div>

        <div className="privacy-section">
          <h2>{t('contact_us')}</h2>
          <p>{t('contact_us_intro')}</p>

          <ul>
            <li>{`${t('via_email')}: info@nawy.com`}</li>
          </ul>
        </div>
      </div>
    </PrivacyContainer>
  );
};

const PrivacyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  padding: 30px 0px;

  .privacy-header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    h1 {
      color: #0c314e;
      font-size: ${props => props.theme.font.sizes.xxl};
      font-family: materialBold;
    }
    p {
      font-family: materialRegular;
      font-size: ${props => props.theme.font.sizes.l};
      color: ${props => props.theme.light.colors.black};
    }
  }
  .privacy-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .privacy-section {
      display: flex;
      flex-direction: column;
      gap: 16px;
      h2 {
        font-family: materialBold;
        font-size: ${props => props.theme.font.sizes.xl};
        color: #0c314e;
      }
      p {
        font-family: materialRegular;
        font-size: ${props => props.theme.font.sizes.l};
        color: ${props => props.theme.light.colors.black};
      }

      ul {
        display: flex;
        flex-direction: column;
        list-style-type: disc;
        padding: 10px 30px;
        gap: 16px;
        font-size: ${props => props.theme.font.sizes.m};
        color: ${props => props.theme.light.colors.black};

        .bold {
          font-family: materialSemiBold;
        }

        div {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }
      }

      .consent-toggler {
        display: flex;
        flex-direction: row;
        font-family: materialMedium;
        font-size: 16px;
        gap: 12px;
        align-items: center;
        color: #212427;
        background-color: #f9fafb;
        padding: 8px;
        width: 320px;
        justify-content: space-between;
        border-radius: 4px;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    padding: 16px;

    padding: 16px;
    h1 {
      font-size: ${props => props.theme.font.sizes.l} !important;
    }
    h2,
    p {
      font-size: ${props => props.theme.font.sizes.s} !important;
    }

    .privacy-content {
      .privacy-section {
        ul {
          font-size: ${props => props.theme.font.sizes.s};
          padding: 5px 20px;
        }
      }
    }
  }
`;

export const getStaticProps = wrapper.getStaticProps(
  store =>
    async ({ params, locale }: GetStaticPropsContext) => {
      const [configVariables, filterOptions] = await Promise.all([
        ConfigsApis.getConfigs(locale),
        getFilterOptions(locale)
      ]);

      if (params?.platform === 'app') {
        store.dispatch(setWebview(WEBVIEW.APP));
      }

      store.dispatch(setIsMobile(params?.device === 'mobile'));
      store.dispatch(setExperimentVariant(params?.variant as string));

      return {
        props: {
          ...(await serverSideTranslations(locale as string, [
            'privacy',
            'common',
            'contact'
          ])),
          filterOptions: JSON.stringify(filterOptions) || '',
          configVariables,
          layout: {
            footerLinks: []
          }
        }
      };
    }
);

export const getStaticPaths = (async () => {
  return { paths: StaticPagesUtility.getWithPlatform(), fallback: false };
}) satisfies GetStaticPaths;

export default Privacy;
